export default {
      id: "pdf-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#pdf",
      toString: function () {
        return this.url;
      }
    }